/**
 * Browser client for the localhost Desk Continuum bridge.
 * Never sends sandbox file contents to the cloud — only tool results stay in-session.
 */

const STORAGE_KEY = 'if-desk-bridge-v1';
export const DEFAULT_BRIDGE_PORT = 7842;
export const DEFAULT_BRIDGE_BASE = `http://127.0.0.1:${DEFAULT_BRIDGE_PORT}`;

export function loadDeskBridgePairing() {
  if (typeof window === 'undefined') return { baseUrl: DEFAULT_BRIDGE_BASE, token: '' };
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : {};
    return {
      baseUrl: parsed.baseUrl || DEFAULT_BRIDGE_BASE,
      token: parsed.token || '',
    };
  } catch {
    return { baseUrl: DEFAULT_BRIDGE_BASE, token: '' };
  }
}

export function saveDeskBridgePairing({ baseUrl, token }) {
  if (typeof window === 'undefined') return;
  localStorage.setItem(STORAGE_KEY, JSON.stringify({
    baseUrl: baseUrl || DEFAULT_BRIDGE_BASE,
    token: token || '',
  }));
}

export function clearDeskBridgePairing() {
  if (typeof window === 'undefined') return;
  localStorage.removeItem(STORAGE_KEY);
}

async function bridgeFetch(baseUrl, path, { method = 'GET', token, body } = {}) {
  const headers = { Accept: 'application/json' };
  if (token) headers['X-Desk-Token'] = token;
  if (body != null) headers['Content-Type'] = 'application/json';
  const res = await fetch(`${String(baseUrl).replace(/\/$/, '')}${path}`, {
    method,
    headers,
    body: body != null ? JSON.stringify(body) : undefined,
  });
  const text = await res.text();
  let data;
  try {
    data = text ? JSON.parse(text) : {};
  } catch {
    data = { raw: text };
  }
  if (!res.ok) {
    const err = new Error(data.message || data.error || `Bridge ${res.status}`);
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
}

export async function deskBridgeHealth(baseUrl = DEFAULT_BRIDGE_BASE) {
  return bridgeFetch(baseUrl, '/health', { method: 'GET' });
}

export async function deskBridgeStatus(baseUrl, token) {
  return bridgeFetch(baseUrl, '/status', { method: 'GET', token });
}

export async function deskBridgeSetDryRun(baseUrl, token, dryRun) {
  return bridgeFetch(baseUrl, '/mode', { method: 'POST', token, body: { dryRun: Boolean(dryRun) } });
}

export async function deskBridgeRunTool(baseUrl, token, tool, args = {}) {
  return bridgeFetch(baseUrl, '/tool', {
    method: 'POST',
    token,
    body: { tool, arguments: args },
  });
}

export async function deskBridgeAudit(baseUrl, token, limit = 40) {
  return bridgeFetch(baseUrl, `/audit?limit=${limit}`, { method: 'GET', token });
}
